import { render, staticRenderFns } from "./ActivityToImage.vue?vue&type=template&id=027939e8&scoped=true&"
import script from "./ActivityToImage.vue?vue&type=script&lang=js&"
export * from "./ActivityToImage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityToImage.vue?vue&type=style&index=0&id=027939e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027939e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VImg,VLayout})
